import { Edit, Plus } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import useMediaQuery from '@/hooks/use-media-query'

type Props = {
  name: string
  href: string
  icon: string
}

const MD_BREAKPOINT = '(min-width: 860px)'

export const ButtonLink: React.FC<Props> = ({ name, href, icon }) => {
  const isDesktop = useMediaQuery(MD_BREAKPOINT)

  const desktopView = () => (
    <Link className='btn-sm btn btn-success' to={href}>
      {icon === 'Plus' && (
        <>
          <Plus size={20} />
          {name}
        </>
      )}
      {icon === 'Edit' && (
        <>
          <Edit size={20} className='me-2' />
          {name}
        </>
      )}
    </Link>
  )
  const mobileView = () => (
    <div className='fab'>
      <Button variant='dark' size="sm" href={href} className='rounded-pill'>
        <Plus size={15} />
      </Button>
    </div>
  )
  return (
    <div className='d-flex justify-content-end'>
      {isDesktop ? desktopView() : mobileView()}
    </div>
  )
}
